import { Input } from "@saleor/macaw-ui-next";
import { useState } from "react";
import { useIntl } from "react-intl";

const MAX_ROLL_SPACING_MM = 50;

// Millimetre field for roll spacing. Keeps the text as typed while editing,
// so "0," or "0." can be finished into 0,5 / 0.5 (a number input turned
// every keystroke straight into a number and lost the separator), and only
// reports values that parse.
export const MillimeterInput = ({
  label,
  value,
  onChange,
}: {
  label: string;
  value: number;
  onChange: (value: number) => void;
}) => {
  const intl = useIntl();
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <Input
      label={label}
      size="small"
      type="text"
      inputMode="decimal"
      value={draft ?? intl.formatNumber(value, { maximumFractionDigits: 2 })}
      onChange={event => {
        const text = event.target.value;
        const parsed = Number(text.trim().replace(",", "."));

        setDraft(text);

        if (text.trim() !== "" && Number.isFinite(parsed) && parsed >= 0) {
          onChange(Math.min(MAX_ROLL_SPACING_MM, parsed));
        }
      }}
      onBlur={() => setDraft(null)}
    />
  );
};
